<template>
  <div class="top-bar">
    <div class="row left-right">
      <div class="row logo-container">
        <div @click="onToHomeClick">
          <img  class="logo" src="../../assets/img/logo.svg" alt="logo" />
        </div>
      </div>
      <div class="row profile-photo">

      <div class="row">
        <LoginDialogBtn @userLogin="userLogin" v-if="userInfo.role === 'Vistor'"></LoginDialogBtn>
        <!-- <img v-if="!isVip && userInfo.role !== 'Vistor'" class="vip-img" src="../../assets/img/no-vip.svg">
        <img v-if="isVip && userInfo.role !== 'Vistor'" class="vip-img" src="../../assets/img/VIP.svg"> -->
        <el-dropdown @command="handleCommand" trigger="click" v-if="userInfo.role !== 'Vistor'">
          <span class="el-dropdown-link">
            {{userInfo.username}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(value, key, index) in options" :key="index" :command="key">{{key}}</el-dropdown-item>
            <el-dropdown-item  command="退出登录">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/rest/questionQuery";
import authService from "@/services/authService";
import LoginDialogBtn from "@/components/common/LoginDialogBtn";
import localStorageHelper from "@/helpers/localStorageHelper";
import { ROLE } from "@/helpers/constants";

export default {
  data() {
    return {
      options: {
        充值会员: "/recharge",
        用户中心: "/userCenter",
        查询历史: "/history",
        我的收藏: "/collection",
        我的反馈: "feedback"
      },
      userInfo: ""
    };
  },
  computed: {
    isVip() {
      if (this.userInfo) {
        return this.userInfo.role.indexOf("VIP") > -1;
        // eslint-disable-next-line
      } else {
        return false;
      }
    }
  },
  methods: {
    userLogin() {
      api.getUserInfo().then(res => {
        this.userInfo = res;
        eventBus.$emit("getUserExpireAt", this.userInfo.expire_at);
        this.userInfo.role = "VIP";
        localStorageHelper.setItem(ROLE, "VIP");
        // if (this.userInfo.role.indexOf('VIP') > -1) {
        //   localStorageHelper.setItem(ROLE, 'VIP');
        // } else {
        //   localStorageHelper.setItem(ROLE, 'NOVIP');
        // }
      });
    },
    async getUserInfo() {
      this.userInfo = await api.getUserInfo();
      eventBus.$emit("getUserExpireAt", this.userInfo.expire_at);
    },
    onToHomeClick() {
      if (this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
        this.getUserInfo();
      }
    },
    handleCommand(command) {
      if (command !== "退出登录") {
        if (this.$router.currentRoute.path !== this.options[command]) {
          this.$router.push(this.options[command]);
        }
      } else if (command === "退出登录") {
        authService.logout();
        if (this.$router.currentRoute.path !== "/") {
          this.$router.push({
            path: "/"
          });
        }
        this.getUserInfo();
        eventBus.$emit("userLogout");
      }
    }
  },
  components: {
    LoginDialogBtn
  },
  created() {
    eventBus.$on("getUserinfo", () => {
      this.getUserInfo();
    });
    eventBus.$on("userLogin", () => {
      this.userLogin();
    });
    eventBus.$on("rechargeResultPage", event => {
      this.userInfo = event;
      if (this.userInfo.role.indexOf("VIP") > -1) {
        localStorageHelper.setItem(ROLE, "VIP");
      } else {
        localStorageHelper.setItem(ROLE, "NOVIP");
      }
    });
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>

<style lang="scss" scoped>
$bgColor: #fff;

.top-bar {
  height: 48px;
  padding: 11px 80px 0;
  background-color: $bgColor;
  border-bottom: 1px solid #f2f3f7;
  z-index: 2;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  .left-right {
    display: flex;
    justify-content: space-between;
    .logo-container {
      height: 26px;
      align-items: center;

      .logo {
        display: block;
        width: 96px;
        height: 28px;
        cursor: pointer;
      }
    }
  }
  .el-dropdown-link {
    cursor: pointer;
  }
}
.vip-img {
  margin-right: 4px;
  margin-top: 2px;
  height: 16px;
  width: 16px;
}
</style>
